import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from 'posthog-js';

// Initialize PostHog
posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST, // e.g., 'https://eventspire.nl/posthog'
    capture_pageview: true,
    debug: process.env.NODE_ENV === 'development',
});

// Optional: make PostHog available globally
window.posthog = posthog;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

reportWebVitals();